import { Component, OnInit,OnChanges,Input,Output,EventEmitter } from '@angular/core';
import { Router,ActivatedRoute} from '@angular/router';
@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnChanges {

  @Input() Pager;
  public nowIndex = 1;
  public perPage = 20;
  public pageList = [];
  public pageTotal = 0;
  public pageShowList = [];
  public lastindex = 0;
  @Output() PageSetEvt = new EventEmitter();
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    
  }

  // ngOnInit() {
  //   //console.log('PaginationComponent ngOnInit',this.pageList);
  // }
  ngOnChanges() {
    ////console.log('Pager',this.Pager);
    this.pageList = [];
    this.pageShowList = [];
    if(this.Pager){
      var pageCount = this.Pager['totalPage'];
      for(var i = 0 ; i < pageCount; i ++){
        this.pageList.push((i+1));
      }
      if(this.Pager['currentPage'] > 1){
        this.nowIndex = this.Pager['currentPage'];
      }else{
        this.nowIndex = 1;
      }
      this.pageTotal = pageCount;
      this.PagerRender();
      // this.nowIndex = pageIndex;
      // this.PageDataSet(this.nowIndex);
    }
  }
  addPage(event){
    event.preventDefault();
    if(this.nowIndex != this.pageList.length && this.nowIndex < this.pageList.length){
      this.nowIndex = this.nowIndex + 1;
      this.PageDataSet(this.nowIndex);
    }
  }
  lessPage(event){
    event.preventDefault();
    if(this.nowIndex != 1 && this.nowIndex <= this.pageList.length){
      this.nowIndex = this.nowIndex - 1;
      this.PageDataSet(this.nowIndex);
    }
  }
  setPage(event,pageIndex){
    event.preventDefault();
    if(pageIndex != this.nowIndex){
      this.nowIndex = pageIndex;
      this.PageDataSet(this.nowIndex);
    }
  }

  setPageV2(event){
    var a = event;
    this.setPage(event,a.target.value);
  }

  PageDataSet(index){
    this.router.navigate(
      [], 
      {
        relativeTo: this.activatedRoute,
        queryParams: { page: index }, 
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
    this.PageSetEvt.emit(index);
    // $("html, body").animate({
    //   scrollTop: 0
    // }, 600);
  }
  PagerRender(){
    if(this.pageList.length > 4){

      var _last = this.pageList[this.pageList.length - 1];
      if(this.nowIndex == 1){
        this.pageShowList = [1,2,3];
      }else{
        if(this.nowIndex != _last){
          var previous = this.pageList[this.nowIndex-2];
          var current = this.nowIndex;
          var next = this.pageList[this.nowIndex];
          this.pageShowList = [previous,current,next];
        }else{
          this.pageShowList = [this.pageList[this.nowIndex-3],this.pageList[this.nowIndex-2],this.nowIndex];
        }
      }

      var _last = this.pageList[this.pageList.length - 1];
      if(this.pageShowList.includes(_last)){
        this.lastindex = 0;
      }else{
        this.lastindex = _last;
      }
      
    }else{
      this.pageShowList = this.pageList;
      this.lastindex = 0;
    }
  }
}
